import * as galleryVideos from "./galleryVideos";

export function init($name = '') {
    let galleries = $($name);

    if (!galleries.length) {
        return;
    }

    galleries.each(function () {
        const gallery = $(this);
        const select = gallery.find($name + '-select');
        const searchbox = gallery.find($name + '-searchbox');

        // if (gallery.find($name + '-slick').length) {
        //     slickRebuild(gallery, $name);
        // }

        let filters = {};

        select.click(function(e) {
            e.stopPropagation();

            $(this).next().slideToggle();
        });

        $('body').click(function() {
            select.next().slideUp();
        });

        select.next().find('li').click(function(e) {
            e.stopPropagation();

            const category = $(this).data('category');
            const categoryLabel = $(this).data('category-label');

            if (category == '') {
              document.location.href = post_info.permalink;
              return;
            }

            document.location.href = post_info.permalink + 'category/' + category + '/';
            return;

            if (categoryLabel) {
                $(this).parent().parent().find($name + '-select').html(categoryLabel);
            } else {
                $(this).parent().parent().find($name + '-select').html($(this).parent().parent().find($name + '-select').data('start-title'));
            }

            history.pushState({}, 'Push state for video gallery filter', post_info.permalink + 'category/' + category + '/');

            $(this).parent().slideUp();

            filters['category'] = String(category);

            triggerFilters(gallery, $name, filters);
        });

        let delay = (function(){
            let timer = 0;
            return function(callback, ms){
                clearTimeout (timer);
                timer = setTimeout(callback, ms);
            };
        })();

        searchbox.on('keyup', function() {
            // let that = $(this);
            let value = $(this).val();

            if (event.keyCode === 13) {
              if (value != '') {
                document.location.href = post_info.current_url + '?title=' + value;
                return;
              } else {
                document.location.href = post_info.current_url;
                return;
              }
            }

            // delay(function(){
            //     filters['title'] = String(that.val());
            //
            //     triggerFilters(gallery, $name, filters, true);
            // }, 1000 );
        });
    });
}

function triggerFilters(gallery, $name, filters, search = false) {
    galleryVideos.destroy();

    var category = '';

    if (filters['category'] !== undefined) {
      category = filters['category'] + '/';
    } else {
      category = $('[data-category-label="' + $('.js-video-gallery-with-filters-select').text() + '"]').data('category') + '/';
    }

    var searchUrl = post_info.permalink + 'category/' + category;

    if (search) {
      searchUrl += '?title=' + filters['title'];
    }

    $.get(searchUrl)
        .done(function( response ) {
            let html = $(response).find($name + '-slick-ajax');

            if (html.length) {
                gallery.find($name + '-slick-ajax').html(html.html());
                galleryVideos.init('.js-trigger-gallery-video');
                slickRebuild(gallery, $name);
            } else {
                gallery.find($name + '-slick-ajax').html('')
            }
        });
}

function slickRebuild(gallery, $name) {
    const slickOptions = {
        infinite: true,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        variableWidth: false,
        centerMode: false,
        fade: false,
        swipe: true,
        swipeToSlide: true,
        prevArrow: '<button type="button" name="Previouse" title="Previouse" value="Previouse" class="slick-prev"><i class="icon icon-arrow_left"></i></button>',
        nextArrow: '<button type="button" name="Next" title="Next" value="Next" class="slick-next"><i class="icon icon-arrow_right"></i></button>'
    };

    gallery.find($name + '-slick').slick(slickOptions);
}
